import clsx from 'clsx'
import update from 'immutability-helper'
import {pick, mapValues} from 'lodash'
import React from 'react'
import {makeStyles} from 'external/material'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import MenuItem from '@mui/material/MenuItem'
import Box from '@mui/material/Box'

import {createPost} from 'helpers/command'
import {pickAttributes} from 'helpers/utils'


const useStyles = makeStyles(questionStyles)

export default function QuestionProperties (props) {

  const {question, index, context} = props
  const {translate, subjects, myCourses, updateState} = context
  const classes = useStyles()

  async function updateProperties (properties, updateCommand) {
    const [updatedId] = await createPost('quiz', 'updateBankQuestionProperties')({id: question.id, ...properties})
    if (updatedId == question.id) {
      updateState({quizQuestionBank: updateCommand})
    }
  }

  function handleSubjectChange (e) {
    const request = {subject: e.target.value, course: undefined}
    const updateCommand = {[index]: {
      subject: {$set: e.target.value},
      course: {$set: undefined},
      courseName: {$set: undefined}
    }}
    updateProperties(request, updateCommand)
  }

  function handleCourseChange(e) {
    const {course, courseName} = myCourses.find(({course}) => course == e.target.value)
    const request = {course}
    const updateCommand = {[index]: {
      course: {$set: course},
      courseName: {$set: courseName}
    }}
    updateProperties(request, updateCommand)
  }

  const courses = question.subject
    ? myCourses.filter(({course}) => course.substring(0,2) == question.subject)
    : myCourses

  return (
    <Box className={classes.root}>
      <SelectProperty
        controlMargin="dense"
        controlClassName={clsx(classes.select, classes.subject)}
        selectValue={question.subject == null ? '' : question.subject}
        selectOnChange={handleSubjectChange}
        caption={translate('subject_label')}
      >
        {subjects.map((subject, key) => {
          return (<MenuItem value={subject.id} key={key}>{subject.name}</MenuItem>)
        })}
      </SelectProperty>
      <SelectProperty
        controlMargin="dense"
        controlClassName={clsx(classes.select, classes.course)}
        selectValue={question.course == null ? '' : question.course}
        selectOnChange={handleCourseChange}
        caption={translate('courseName-header')}
      >
        {courses.map((course, key) => {
          return (<MenuItem value={course.course} key={key} >{course.courseName}</MenuItem>)
        })}
      </SelectProperty>
  </Box>)
}


function SelectProperty (props) {

  const controlAttributes = pickAttributes(props, 'control')
  const labelAttributes = pickAttributes(props, 'label')
  const selectAttributes = pickAttributes(props, 'select')

  const labelId = `${props.id}-label`

  return (
      <FormControl {...controlAttributes}>
        <InputLabel shrink id={labelId} {...labelAttributes} className="label">{props.caption}:</InputLabel>
        <Select
          labelId={labelId}
          id={props.id}
          {...selectAttributes}
          className="select"
        >
          {props.children}
        </Select>
      </FormControl>
  )
}

function questionStyles(theme) {
  return {
    root: {
      display: 'flex',
      flexGrow: 1,
    },
    select: {
      marginLeft: 15,
      minWidth: 200,
      '&:first-child': {
        marginLeft: 0
      },
      '& .MuiInput-underline:before': {
        content: 'none',
        border: 'none'
      },
      '& .MuiSelect-select': {
        // border: 'solid 1px #aab7bf',
        borderRadius: 4,
        padding: '4px 24px 4px 8px',
        marginTop: 5
      },
      '& > .label': {
        fontSize: '15pt',
        color: '#4e566b',
        margin: '-11px' 
      }
    },
  }
}
